export const formatNumberWithCommas = (number: number | undefined) => {
  if (!number) return 0;

  const hasDecimal = number % 1 !== 0;

  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal ? 2 : 0,
  }).format(number);

  return formattedNumber;
};
